import { gate } from 'hub-http/gates';
export const HUBSPOT_RTE_MIGRATION_ENABLED = 'MO:CollaborationSidebar:HubSpotRTEMigration';
export const REALTIME_COMMENTING_ENABLED = gate('MarketingPlatform::RealtimeCommenting');